module.exports = __webpack_public_path__ + "img/wax-logo.2d890aa4.webp";